const { host } = window.location;

const getEnv = () => /localhost/i.test(host);

const webSocketUrl = (getEnv() ? 'ws://' : 'wss://') + host;

const urlCdn = process.env.REACT_APP_CISS_CDN_URL;
const baseURL = '/proxy';

export { webSocketUrl, urlCdn, baseURL };

export default getEnv;
